import React from "react";
import { Reveal, SectionHeader } from "@/components/ui-blocks/Reveal";
import { ContactForm } from "@/components/forms/ContactForm";
import { NewsletterForm } from "@/components/forms/NewsletterForm";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { useSite } from "@/lib/site";

export const ContactSection = () => {
  const site = useSite();
  return (
  <section id="contact" className="bg-background">
    <div className="container-wide py-16 lg:py-24">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <SectionHeader eyebrow="Contact" title="Talk to us." lead="Media queries, partnerships, general enquiries — we’re here to help." />
          <div className="rounded-xl border border-[hsl(var(--border))] bg-card p-6"><ContactForm /></div>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.05}>
            <div className="rounded-xl border border-[hsl(var(--border))] p-6 bg-[hsl(var(--surface-tint))] space-y-4">
              <Info Icon={Mail} label="Email" value={site.contact_email} />
              <Info Icon={Phone} label="Phone" value={site.contact_phone} />
              <Info Icon={MapPin} label="Head Office" value={site.address} />
              <Info Icon={Clock} label="Office hours" value="Mon–Fri • 10:00 AM – 6:30 PM IST" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-6 rounded-xl border border-[hsl(var(--border))] p-6 bg-card">
              <div className="eyebrow">Newsletter</div>
              <h3 className="heading-3 mt-1 text-lg">Monthly impact updates</h3>
              <p className="text-sm text-[hsl(var(--muted-ink))] mt-1">Program milestones, campaigns, transparency reports.</p>
              <div className="mt-3"><NewsletterForm /></div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
  );
};

const Info = ({ Icon, label, value }) => (
  <div className="flex items-start gap-3">
    <div className="h-9 w-9 rounded-md bg-card border border-[hsl(var(--border))] text-[hsl(var(--navy))] grid place-items-center"><Icon className="h-4.5 w-4.5" /></div>
    <div><div className="text-xs uppercase tracking-widest text-[hsl(var(--muted-ink))]">{label}</div><div className="font-semibold text-[hsl(var(--navy))]">{value}</div></div>
  </div>
);
